import classNames                   from 'classnames';
import * as PropTypes               from 'prop-types';
import React, { useMemo } from 'react';
import { useTranslation }           from 'react-i18next';
import { Link }                     from 'react-router-dom';

import { OffersSlider, Price } from '../../../../new-components';

const SearchDoorItem = (props) => {
  const {
          offers,
          close,
        }     = props;
  const { t } = useTranslation();

  const current = useMemo(() => {
    return Object.values(offers)[0];
  }, [offers]);

  const {
          common: {
                    label,
                    urlKey,
                    constructionTypeId,
                    vendorCode,
                    price,
                    discountPrice,
                    isInterior,
                    isExpressMarker,
                    isMarker,
                    isSpecMarker,
                    showDiscountPrice,
                  },
        } = current;

  return (
    <Link
      to={urlKey}
      className={classNames('item card inline ', {
        'double':   constructionTypeId === 2,
        'interior': isInterior,
      })}
      onClick={close}
    >
      <div className={'picture'}>
        <OffersSlider
          current={+Object.keys(offers)[0]}
          inline
          offers={offers}
          showOffers
        />
      </div>
      <div>
        <div className={'title'}>
          {label}
        </div>
        <div className={'sku'}>
          {t('client_vendorCode')}: {vendorCode}
        </div>
        {!isInterior && (
          <Price
            discountPrice={discountPrice}
            isExpressMarker={isExpressMarker}
            isMarker={isMarker}
            isSpecMarker={isSpecMarker}
            price={price}
            showDiscountPrice={showDiscountPrice}
          />
        )}
      </div>
    </Link>
  );

};

SearchDoorItem.propTypes = {
  offers: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  close:  PropTypes.func.isRequired,
};

export default SearchDoorItem;